module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loading-image-wrapper"
  }, [_c('div', {
    staticClass: "white loading-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "blue loading-image"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ad1319d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Loader.vue
// module id = 2021
// module chunks = 2